import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store(
{
    plugins: [createPersistedState()],
	state:
	{
		user: 				null,
        grant_type: 		"password",
        client_id: 			"1",
        client_secret: 		"KB1OD3PeCjInjdmJ13bGJQz3RfvceEItO3RKmLuS",
		checkoutList:		[],
		saved_product: null,
	},
	mutations:
	{
		login (state, data)
		{

		},
		logout (state)
		{
			state.user 				= null;
		},
		store_user (state, user)
		{
			state.user = user;
		},
		store_checkout (state, checkoutList)
		{
			state.checkoutList = checkoutList;
		},
		store_saved_product (state, product)
		{
			state.saved_product = product;
		}
	},
    getters: {
        getUser : state => state.user,
    },
	actions:
	{
	}
})